import Service from './Service';

class GepjarmutorzsService extends Service {
    getGepjarmuLista(rendszam = '', ceg, page = 1) {
        return this.get(`/vehicle/${ceg}?`, { rendszam, page, list: 1 });
    }

    getGepjarmu(ceg, rendszam) {
        return this.get(`/vehicle/${ceg}?`, {
            rendszam,
        });
    }

    saveNewGepjarmu(gepjarmu, ceg) {
        return this.post(`/vehicle/${ceg}`, {
            gepjarmu,
        });
    }

    saveGepjarmu(gepjarmu, ceg) {
        return this.post(`/vehicle/${ceg}?rendszam=${gepjarmu.regirendszam}`, {
            gepjarmu,
        });
    }
}

export default new GepjarmutorzsService('/vehicle');
